import { api } from '../api'

// todo interface
type IResourceResponse = {
  data?: any
  current_page?: number
  first_page?: number
  last_page?: number
}

export const resourcesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getResources: builder.query<
      IResourceResponse,
      { developerId: number; payload?: any }
    >({
      query: ({ developerId, payload }) => {
        return {
          url: `/companies/${developerId}/resources`,
          params: payload,
        }
      },
      providesTags: <any>['Resource'],
    }),
    getSingleResource: builder.query<
      IResourceResponse,
      { developerId: number; media: number }
    >({
      query: ({ developerId, media }) => {
        return {
          url: `/companies/${developerId}/resources/${media}`,
        }
      },
    }),
  }),
})

export const { useGetResourcesQuery, useGetSingleResourceQuery } = resourcesApi
